module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-3.40f47038.png";